import React, { ReactElement } from "react";
import dynamic from "next/dynamic";
import CategoryBanner from "@components/contentintelligence/categoryBanner";

const CategoryIntro = dynamic(
    () => import("@components/contentintelligence/categoryIntro"),
);
const CategoryOutro = dynamic(
    () => import("@components/contentintelligence/categoryOutro"),
);
const Benefits = dynamic(() => import("../benefits"));

export default function HomePage(): ReactElement {
    return (
        <>
            <CategoryBanner />
            <CategoryIntro />
            <Benefits />
            <CategoryOutro />
        </>
    );
}
